import { getRedirectRules } from "@faire/retailer-visitor-shared/initializers/redirectRules";
import Redirects from "@faire/retailer-visitor-shared/services/Redirects";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { History } from "history";

export const watchForRedirects = (
  history: History,
  user: IUser | undefined
) => {
  new Redirects(getRedirectRules(user)).listen(history);
};
